import { useEffect, useState } from "react";
import api from "./api";

// Compagnie dello studio che NON aderiscono alla convenzione di risarcimento diretto.
const norm = (s) => String(s || "").replace(/\s+/g, " ").trim().toLowerCase();
let cache = new Set();
let promise = null;

const load = () => {
  if (!promise) {
    promise = api.get("/studio/compagnie-non-aderenti")
      .then(({ data }) => { cache = new Set((data || []).map(norm)); return cache; })
      .catch(() => { promise = null; return cache; });
  }
  return promise;
};

export const isNonAderente = (name) => !!name && cache.has(norm(name));

export function useNonAderenti() {
  const [, setTick] = useState(0);
  useEffect(() => { load().then(() => setTick((t) => t + 1)); }, []);
  return isNonAderente;
}

export const NON_ADERENTE_MSG = "La compagnia di controparte non aderisce alla convenzione: gestionaria = compagnia controparte";
